<template>
  <v-data-table
    :expanded="tableMixin_expandedRows"
    :footer-props="{
      'items-per-page-options': [pagination.per_page],
    }"
    :items-per-page="pagination.per_page"
    :headers="tableMixin_displayedHeaders"
    :items="displayedItems"
    :mobile-breakpoint="0"
    :page="pagination.current_page"
    :server-items-length="pagination.total"
    :class="{ 'content-loading': loading }"
    class="article-table"
    disable-sort
    @update:page="tableMixin_changePage"
    @click:row="tableMixin_onRowClick"
  >
    <template v-slot:item.handle>
      <v-icon class="draggable">mdi-drag</v-icon>
    </template>

    <template v-slot:item.image="{ item }">
      <v-img
        v-if="item.images.length"
        :src="$backendUrl(item.images[0].image_path)"
        :alt="item.images[0].original_name"
        class="clickable"
        height="100px"
        width="100px"
        contain
        @click.stop="viewImages(item)"
      />
    </template>

    <template v-slot:item.type="{ item }">
      {{ $t(item.type) }}
    </template>

    <template v-slot:item.description="{ item }">
      <div class="link" @click="displayFormatedText(item)">
        {{ $t('click_here_to_view') }}
      </div>
    </template>

    <template v-slot:item.translatedStatus="{ item }">
      <v-chip
        :color="!item.is_published ? 'grey lighten-4' : 'green accent-2'"
        class="text-caption persist-opacity"
        label
        small
      >
        {{ item.translatedStatus }}
      </v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <BaseActionMenu :actions="getRowActions(item)" :item="item" />
    </template>

    <template v-slot:expanded-item="{ item }">
      <BaseExpandedTableRow
        :colspan="tableMixin_displayedHeaders.length"
        :headers="tableMixin_hiddenHeaders"
        :item="item"
      >
        <template v-slot:item.image>
          <v-img
            v-if="item.images.length"
            :src="$backendUrl(item.images[0].image_path)"
            :alt="item.images[0].original_name"
            height="100px"
            width="100px"
            class="clickable"
            contain
            @click="viewImages(item)"
          />
        </template>

        <template v-slot:item.description>
          <div v-html="item.description">
            {{ item.description }}
          </div>
        </template>

        <template v-slot:item.translatedStatus>
          <v-chip
            :color="!item.is_published ? 'grey lighten-4' : 'green accent-2'"
            class="text-caption persist-opacity"
            label
            small
          >
            {{ item.translatedStatus }}
          </v-chip>
        </template>
      </BaseExpandedTableRow>
    </template>
  </v-data-table>
</template>

<script>
import { Sortable } from 'sortablejs';
import tableMixin from '../mixins/table-mixin';
import BaseActionMenu from './base/BaseActionMenu';
import BaseExpandedTableRow from './base/BaseExpandedTableRow';

export default {
  name: 'ArticleTable',

  components: { BaseActionMenu, BaseExpandedTableRow },

  mixins: [tableMixin],

  props: {
    items: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    disabledItemIds: {
      type: Object,
      default: () => ({}),
    },
    loading: Boolean,
  },

  mounted() {
    const table = document.querySelector('.article-table tbody');
    Sortable.create(table, {
      animation: 150,
      handle: '.draggable',
      onStart: () => {
        this.tableMixin_expandedRows = [];
      },
      onEnd: ({ newIndex, oldIndex }) => {
        this.$emit('reorder', newIndex, oldIndex);
      },
    });
  },

  computed: {
    headers() {
      return [
        {
          value: 'handle',
          width: 10,
        },
        {
          text: this.$t('image'),
          value: 'image',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('title'),
          value: 'title',
        },
        {
          text: this.$t('type'),
          value: 'type',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('status'),
          value: 'translatedStatus',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('description'),
          value: 'description',
          hidden: 'smAndDown',
        },
        {
          value: 'actions',
          align: 'end',
        },
      ];
    },

    displayedItems() {
      if (!this.items) {
        return [];
      }
      return this.items.map((r) => ({
        ...r,
        translatedStatus: this.$t(
          `contact_status.${r.is_published ? 'published' : 'not_published'}`,
        ),
      }));
    },
  },

  methods: {
    getRowActions() {
      const actions = [
        {
          callback: (p) => this.$emit('edit', p),
          label: this.$t('edit'),
          icon: 'mdi-pencil',
        },
        {
          callback: (p) => this.$emit('delete', p),
          label: this.$t('delete'),
          icon: 'mdi-delete',
        },
      ];
      return actions;
    },

    viewImages(article) {
      this.$emit('click:image', article);
    },

    displayFormatedText(event) {
      this.$emit('click:text', event);
    },
  },
};
</script>
